import {Box, Flex, Icon, Stack, StackDivider} from '@chakra-ui/react';
import { FC } from 'react';
import { ParagraphFarmCategoryTeaserFragment } from '../../../generated/types';
import {IoCheckmarkCircle} from "@react-icons/all-files/io5/IoCheckmarkCircle";

interface FarmCategoryListProps {
  categories: ParagraphFarmCategoryTeaserFragment[];
}

export const FarmCategoryList: FC<FarmCategoryListProps> = ({ categories }) => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      flexWrap="wrap"
      divider={<StackDivider borderColor="gray.300" />}
      spacing={2}
      fontSize={{
        base: 'sm',
        md: 'md'
      }}
    >
      {categories.map((categoryParagraph, i) => {
        const allCategories = [
          categoryParagraph.category,
          ...categoryParagraph.subCategories,
        ].filter((category) => category.showInTeaser);

        return allCategories.map((cat, j) => {
          return <Flex key={j} alignItems="center">
            <Icon
                mr={1}
                fontSize="md"
                as={IoCheckmarkCircle}
                color="primary"
            />
            {cat.title}
          </Flex>;
        });
      })}
    </Stack>
  );
};
